import { labCarbonRoutes } from 'constants/routes';

import { ByBarcode } from 'store/samples/types';

export const handleBulkDensitySearchResult = (
  byBarcode: ByBarcode,
  searchBarcode: string,
  setInputValue: (value: string) => void,
  navigate: (route: string) => void,
): void => {
  const barCodeKeys = Object.keys(byBarcode);
  if (byBarcode[searchBarcode]?.length) {
    setInputValue('');
    navigate(labCarbonRoutes.routes.bulkDensityInput(searchBarcode));
  } else if (barCodeKeys.length && byBarcode[barCodeKeys[0]][0].sample_uuid === searchBarcode) {
    setInputValue('');
    navigate(labCarbonRoutes.routes.bulkDensityInput(barCodeKeys[0]));
  }
};
